/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BootstrapDeviceDrivingStatuses,
  BootstrapDriverTranscripts,
  BootstrapLatestUnreadEventPerFeed,
  BootstrapWorkspaceAccounts,
  BootstrapWorkspaceCommandAliases,
  BootstrapWorkspaceFeedGroupMemberships,
  BootstrapWorkspaceFeedGroups,
  BootstrapWorkspaceFeedItems,
  BootstrapWorkspaceFeedPermissions,
  BootstrapWorkspaceFeedPreferences,
  BootstrapWorkspaceFeeds,
  BootstrapWorkspaceMembershipAvailabilities,
  BootstrapWorkspaceMembershipTags,
  BootstrapWorkspaceMemberships,
  BootstrapWorkspaceTags,
  BootstrapWorkspaceTemplates,
  BootstrapWorkspacesResponse,
  TranscriptionFormatType,
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class Bootstrap<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name WorkspacesList
   * @request GET:/bootstrap/workspaces
   */
  workspacesList = (params: RequestParams = {}) =>
    this.request<BootstrapWorkspacesResponse, any>({
      path: `/bootstrap/workspaces`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesDriverTranscriptsDetail
   * @request GET:/bootstrap/workspaces/{id}/driver-transcripts
   */
  workspacesDriverTranscriptsDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
      /** @default "en" */
      language?: string;
      format?: TranscriptionFormatType;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapDriverTranscripts, any>({
      path: `/bootstrap/workspaces/${id}/driver-transcripts`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesAccountsDetail
   * @request GET:/bootstrap/workspaces/{id}/accounts
   */
  workspacesAccountsDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapWorkspaceAccounts, any>({
      path: `/bootstrap/workspaces/${id}/accounts`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesAliasFeedLatestOwnerItemsDetail
   * @request GET:/bootstrap/workspaces/{id}/alias-feed-latest-owner-items
   */
  workspacesAliasFeedLatestOwnerItemsDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapWorkspaceFeedItems, any>({
      path: `/bootstrap/workspaces/${id}/alias-feed-latest-owner-items`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesCommandAliasesDetail
   * @request GET:/bootstrap/workspaces/{id}/command-aliases
   */
  workspacesCommandAliasesDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapWorkspaceCommandAliases, any>({
      path: `/bootstrap/workspaces/${id}/command-aliases`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesDeviceDrivingStatusesDetail
   * @request GET:/bootstrap/workspaces/{id}/device-driving-statuses
   */
  workspacesDeviceDrivingStatusesDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapDeviceDrivingStatuses, any>({
      path: `/bootstrap/workspaces/${id}/device-driving-statuses`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesFeedGroupMembershipsDetail
   * @request GET:/bootstrap/workspaces/{id}/feed-group-memberships
   */
  workspacesFeedGroupMembershipsDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapWorkspaceFeedGroupMemberships, any>({
      path: `/bootstrap/workspaces/${id}/feed-group-memberships`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesFeedGroupsDetail
   * @request GET:/bootstrap/workspaces/{id}/feed-groups
   */
  workspacesFeedGroupsDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapWorkspaceFeedGroups, any>({
      path: `/bootstrap/workspaces/${id}/feed-groups`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesFeedPermissionsDetail
   * @request GET:/bootstrap/workspaces/{id}/feed-permissions
   */
  workspacesFeedPermissionsDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
      mine?: boolean | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapWorkspaceFeedPermissions, any>({
      path: `/bootstrap/workspaces/${id}/feed-permissions`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesFeedPreferencesDetail
   * @request GET:/bootstrap/workspaces/{id}/feed-preferences
   */
  workspacesFeedPreferencesDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
      mine?: boolean | null;
      feedId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapWorkspaceFeedPreferences, any>({
      path: `/bootstrap/workspaces/${id}/feed-preferences`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesFeedsDetail
   * @request GET:/bootstrap/workspaces/{id}/feeds
   */
  workspacesFeedsDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
      mine?: boolean | null;
      feedId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapWorkspaceFeeds, any>({
      path: `/bootstrap/workspaces/${id}/feeds`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesFeedItemsDetail
   * @request GET:/bootstrap/workspaces/{id}/feed-items
   */
  workspacesFeedItemsDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
      feedId?: string;
      sortAscending?: boolean | null;
      itemId?: string;
      useCreatedAt?: boolean | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapWorkspaceFeedItems, any>({
      path: `/bootstrap/workspaces/${id}/feed-items`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesLatestUnreadEventPerFeedForOrganizersDetail
   * @request GET:/bootstrap/workspaces/{id}/latest-unread-event-per-feed-for-organizers
   */
  workspacesLatestUnreadEventPerFeedForOrganizersDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapLatestUnreadEventPerFeed, any>({
      path: `/bootstrap/workspaces/${id}/latest-unread-event-per-feed-for-organizers`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesLatestUnreadEventPerFeedDetail
   * @request GET:/bootstrap/workspaces/{id}/latest-unread-event-per-feed
   */
  workspacesLatestUnreadEventPerFeedDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapLatestUnreadEventPerFeed, any>({
      path: `/bootstrap/workspaces/${id}/latest-unread-event-per-feed`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesNonAliasFeedLatestItemsDetail
   * @request GET:/bootstrap/workspaces/{id}/non-alias-feed-latest-items
   */
  workspacesNonAliasFeedLatestItemsDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapWorkspaceFeedItems, any>({
      path: `/bootstrap/workspaces/${id}/non-alias-feed-latest-items`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesTagsDetail
   * @request GET:/bootstrap/workspaces/{id}/tags
   */
  workspacesTagsDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapWorkspaceTags, any>({
      path: `/bootstrap/workspaces/${id}/tags`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesTemplatesDetail
   * @request GET:/bootstrap/workspaces/{id}/templates
   */
  workspacesTemplatesDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapWorkspaceTemplates, any>({
      path: `/bootstrap/workspaces/${id}/templates`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesWorkspaceMembershipAvailabilitiesDetail
   * @request GET:/bootstrap/workspaces/{id}/workspace-membership-availabilities
   */
  workspacesWorkspaceMembershipAvailabilitiesDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapWorkspaceMembershipAvailabilities, any>({
      path: `/bootstrap/workspaces/${id}/workspace-membership-availabilities`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesWorkspaceMembershipsTagsDetail
   * @request GET:/bootstrap/workspaces/{id}/workspace-memberships/tags
   */
  workspacesWorkspaceMembershipsTagsDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapWorkspaceMembershipTags, any>({
      path: `/bootstrap/workspaces/${id}/workspace-memberships/tags`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @name WorkspacesWorkspaceMembershipsDetail
   * @request GET:/bootstrap/workspaces/{id}/workspace-memberships
   */
  workspacesWorkspaceMembershipsDetail = (
    id: string,
    query?: {
      /** @min 0 */
      page?: number | null;
      /**
       * @min 0
       * @exclusiveMin true
       */
      pageSize?: number;
      timestamp?: string | null;
    },
    params: RequestParams = {},
  ) =>
    this.request<BootstrapWorkspaceMemberships, any>({
      path: `/bootstrap/workspaces/${id}/workspace-memberships`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
}
